import {
    GET_DEFENSES_FAIL,
    GET_DEFENSES_SUCCESS,
    ADD_DEFENSE_SUCCESS,
    ADD_DEFENSE_FAIL,
    UPDATE_DEFENSE_SUCCESS,
    UPDATE_DEFENSE_FAIL,
    DELETE_DEFENSE_SUCCESS,
    DELETE_DEFENSE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    defenses: [],
    error: null,
    loading: true
};

const defenseReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des defenses
        case GET_DEFENSES_SUCCESS:
            return {
                ...state,
                defenses: action.payload, // tableau d'objets defense
                loading: false,
                error: null
            };

        case GET_DEFENSES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une defensee
        case ADD_DEFENSE_SUCCESS:
            return {
                ...state,
                defenses: [action.payload, ...state.defenses], // ajoute au début du tableau
                error: null
            };

        case ADD_DEFENSE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une defensee
        case UPDATE_DEFENSE_SUCCESS:
            return {
                ...state,
                defenses: state.defenses.map(defense =>
                    defense.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet defense
                        : defense
                ),
                error: null
            };

        case UPDATE_DEFENSE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une defensee
        case DELETE_DEFENSE_SUCCESS:
            return {
                ...state,
                defenses: state.defenses.filter(
                    defense => defense.id !== action.payload
                ),
                error: null
            };


        case DELETE_DEFENSE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default defenseReducer;
